import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Item } from 'my-lib-sanfelici/my-lib-sanfelici';
import { ItemsService } from 'my-lib-sanfelici';


@Component({
  selector: 'app-items-search',
  templateUrl: './items-search.component.html',
  styleUrls: ['./items-search.component.css']
})
export class ItemsSearchComponent implements OnInit {  
   @Output() onSearch = new EventEmitter<Item[]>();
   items: Observable<Item[]>;
  constructor(
    private itemsservice: ItemsService) { }
  search($ev) {
    const target = $ev.target.value;
    this.itemsservice.search(target,'item').then(o=>{
      this.onSearch.emit(o);
      this.items = of(o);
    });
  }
  ngOnInit() {
  }

}
